// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2wwa0","error":"Textarea_error__2CpAr","readonly":"Textarea_readonly__tSVSp","disabled":"Textarea_disabled__1LOXZ"};